export const environmentProduction = {
  name: 'production',
  production: true,
  sentry:
    'https://1a8cd8f8486b8194bc14b4f091f366f0@o508829.ingest.us.sentry.io/4507748416552960',
  mixpanel: '5e5375f5d2bf0c2d687cb4c20667978c',
  googleAnalyticsTrackingId: 'G-JNNMQQ0TB7',
  facebookAppId: '1418582178815720',
  recaptchaSiteKey: '6Ldh4yQqAAAAAA3VM7jj1GyhzJ-5txb0xtzV-9fL',
};
